import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_URL;

console.log("API Base URL:", API_BASE_URL);
// Create axios instance
const api = axios.create({
  baseURL: API_BASE_URL + "/api",
  headers: {
    "Content-Type": "application/json",
  },
});

// Request interceptor to add auth token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor for error handling
api.interceptors.response.use(
  (response) => response.data,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      window.location.href = "/login";
    }
    return Promise.reject(error);
  }
);

// Auth services
export const authService = {
  login: (credentials) => api.post("/auth/login", credentials),
  register: (userData) => api.post("/auth/register", userData),
  getProfile: () => api.get("/auth/profile"),
  updateProfile: (profileData) => api.put("/auth/profile", profileData),
  changePassword: (passwordData) =>
    api.post("/auth/change-password", passwordData),
  verifyToken: () => api.get("/auth/verify"),
};

// Lelang services
export const lelangService = {
  getAll: () => api.get("/lelang"),
  getActive: () => api.get("/lelang/active"),
  getById: (id) => api.get(`/lelang/${id}`),
  create: (lelangData) =>
    api.post("/lelang", lelangData, {
      headers: {
        "Content-Type": "multipart/form-data",
        // Jangan set Authorization header secara manual karena akan dihandle oleh interceptor
      },
    }),
  update: (id, lelangData) =>
    api.put(`/lelang/${id}`, lelangData, {
      headers: { "Content-Type": "multipart/form-data" },
    }),
  delete: (id) => api.delete(`/lelang/${id}`),
  updateStatus: (id, status) => api.patch(`/lelang/${id}/status`, { status }),
};

// Bid services
export const bidService = {
  create: (bidData) => api.post("/bid", bidData),
  getUserBids: () => api.get("/bid/user"),
  getBidHistory: (lelangId) => api.get(`/bid/lelang/${lelangId}`),
  getHighestBid: (lelangId) => api.get(`/bid/lelang/${lelangId}/highest`),
};

// Peserta services
export const pesertaService = {
  daftar: (pesertaData) =>
    api.post("/peserta/daftar", pesertaData, {
      headers: { "Content-Type": "multipart/form-data" },
    }),
  getByUser: () => api.get("/peserta/user"),
  getByLelang: (lelangId) => api.get(`/peserta/lelang/${lelangId}`),
};

// Health check
export const healthService = {
  check: () => api.get("/health"),
  detailed: () => api.get("/health/detailed"),
};

// Notification services
export const notificationService = {
  getAll: () => api.get("/notifications"),
  getUnreadCount: () => api.get("/notifications/unread-count"),
  markAsRead: (id) => api.patch(`/notifications/${id}/read`),
  markAllAsRead: () => api.patch("/notifications/mark-all-read"),
  delete: (id) => api.delete(`/notifications/${id}`),
};

export const pemenangService = {
  getByLelang: (lelangId) => api.get(`/pemenang/lelang/${lelangId}`),
  getMyWins: () => api.get("/pemenang/user/my-wins"),
  getAll: () => api.get("/pemenang"),
  tentukanPemenang: (lelangId) =>
    api.post(`/pemenang/lelang/${lelangId}/tentukan`),
  updateStatusPembayaran: (pemenangId, statusPembayaran) =>
    api.patch(`/pemenang/${pemenangId}/pembayaran`, {
      status_pembayaran: statusPembayaran,
    }),
  getStats: () => api.get("/pemenang/stats"),
};

export default api;
